import { handleFundPdf } from "containers/services/data.transformers";
import { useRef, useState } from "react";
import OnbButton from "./button";
import OnbSteps from "./steps";
import PdfViewer from "components/pdfViewr";

const OnbStages = ({ data, current, loading, onClick }) => {
  const failed = data?.stages?.filter((item) => item.status === "FAILED")[0];
  const rulesModal = useRef();
  const [disabled, setDisabled] = useState(true);

  const onChangeRules = (e) => {
    setDisabled(e.target.checked ? false : true);
  };

  const handleRulesClick = () => {
    rulesModal?.current?.showModal();
  };

  return (
    <>
      <OnbSteps data={data} currentData={current} failed={failed} />
      <OnbButton
        data={data}
        onChangeRules={onChangeRules}
        handleRulesClick={handleRulesClick}
        disabled={disabled}
        current={current}
        loading={loading}
        failed={failed}
        onClick={onClick}
      />
      <PdfViewer
        pdf={`https://cdn.firouzeh.com/public/terms/term-bank.pdf`}
        modalRef={rulesModal}
      />
    </>
  );
};
export default OnbStages;
